export enum PEAK_SEASON_TYPE {
  CUSTOMIZE = 'Customize',
  LUNAR_HOLIDAY = 'LunarHoliday',
  SOLAR_HOLIDAY = 'SolarHoliday',
}

export type TPeakSeasonConfig = {
  code?: string;
  name: string;
  description: string;
  startFrom: string;
  endTo: string;
  type: PEAK_SEASON_TYPE;
};

export type TGetPeaksParams = {
  type: PEAK_SEASON_TYPE;
};

export type TGetPeakParams = {
  code: string;
};

export type TDeletePeakPayload = TGetPeakParams;

export type THolidayConfigFormType = {
  lunarDays?: TPeakSeasonConfig[];
  solarDays?: TPeakSeasonConfig[];
};
